"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillPaperImage = void 0;
var react_1 = __importDefault(require("react"));
var BillPaperImage = function (props) {
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { opacity: "0.4", x: "9.75", y: "9.55713", width: "25.2417", height: "33.1235", fill: "currentColor" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2042 37.2009V6H38.446V37.2009H13.2042ZM17.1709 24.3295H28.0788V21.4783H17.1709V24.3295ZM17.1709 18.627H34.4795V15.7757H17.1709V18.627ZM17.1709 12.9245H34.4795V10.0732H17.1709V12.9245ZM24 30.1929L27.9375 34.5L34.5 27.2357L32.5313 25.5L27.9375 30.5786L25.9688 28.4571L24 30.1929Z", fill: "currentColor" })));
};
exports.BillPaperImage = BillPaperImage;
